import { render, staticRenderFns } from "./Banner008PrimerosDulcesSuenos.vue?vue&type=template&id=620c7003"
import script from "./Banner008PrimerosDulcesSuenos.vue?vue&type=script&lang=js"
export * from "./Banner008PrimerosDulcesSuenos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports